import LogsPdfManagerContainer from "components/app/tool/logsPdf/LogsPdfManagerContainer";
import React from "react";

type Props = {};

const LogsPdf = (props: Props) => {
	return <LogsPdfManagerContainer />;
};

export default LogsPdf;
